// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".google-btn[data-v-b7b40fa4] .basic-button__content{display:flex;align-items:center;gap:8px}", ""]);
// Exports
module.exports = exports;
